import classNames from "classnames";
import { FC, useEffect, useMemo } from "react";

import Modal from "components/Modal";

import ModalCreatePortfolioContent, { PortfolioFormValues } from "./Content";

import { RootStore } from "store";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { getCompanyUsersRequest } from "store/slices/companiesSlice";
import { getModalCallbacks } from "store/slices/modalCallbacksRegistry";

import styles from "./styles.module.scss";

type PropTypes = {
  isVisible: boolean;
  className?: string;
  mode?: "create" | "edit";
  portfolioId?: number;
  initialData?: PortfolioFormValues;
  callbackKey?: string;
  isShowCompanySelect?: boolean;
  companyId?: number;
};

const WidgetModalCreatePortfolio: FC<PropTypes> = ({
  isVisible,
  className,
  mode = "create",
  initialData,
  callbackKey,
  isShowCompanySelect,
  companyId,
}) => {
  const dispatch = useAppDispatch();
  const { isLoading } = useAppSelector((state: RootStore) => state.portfolios);
  const callbacks = useMemo(() => (callbackKey ? getModalCallbacks(callbackKey) : undefined), [callbackKey]);
  const onSubmit = useMemo(() => callbacks?.onSave, [callbacks]);

  const title = mode === "create" ? "Create new portfolio" : "Edit portfolio";
  const description = mode === "create" ? "Add a new portfolio to your company" : "Update portfolio information";

  useEffect(() => {
    if (companyId) {
      dispatch(getCompanyUsersRequest({ companyId }));
    }
  }, [companyId, dispatch]);

  return (
    <Modal title={title} isClose isCloseBg isVisible={isVisible} className={classNames(styles.modal, className)}>
      <ModalCreatePortfolioContent
        isShowCompanySelect={isShowCompanySelect}
        mode={mode}
        description={description}
        initialData={initialData}
        onSubmit={onSubmit}
        companyId={companyId}
        isLoading={isLoading}
      />
    </Modal>
  );
};

export default WidgetModalCreatePortfolio;
